import Vue from "vue";

const END_POINT = "/account";

const getAccountRoles = async () => {
  return await Vue.axios.get(END_POINT + "/get-roles").then((resp) => {
    return resp.data;
  });
};

const getActiveUsers = () => Vue.axios.get(END_POINT + "/jwt/active");

const removeActiveUser = (id) =>
  Vue.axios.delete(END_POINT + "/jwt/delete/" + id);

const getAccount = async () => {
  const res = await Vue.axios.get("/account/get-my-account");
  return res.data;
};

const getAccountDashboardConfig = async (id) => {
  const res = await Vue.axios.get(`/account/${id}/default-dashboard-config`);
  return res.data;
};

const updateAccountDashboardConfig = async (id, payload) => {
  const res = await Vue.axios.put(
    `/account/${id}/default-dashboard-config`,
    payload,
  );
  return res.data;
};

export {
  getAccountRoles,
  getActiveUsers,
  removeActiveUser,
  getAccount,
  getAccountDashboardConfig,
  updateAccountDashboardConfig,
};
